// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputWithLabel_inputContainer__30JXI","icon":"InputWithLabel_icon__BQQ4P"};